import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'role'
})
export class RolePipe implements PipeTransform {

  constructor(
    private dom: DomSanitizer
  ){}
  transform(value:any ): any {
      let str = "";
      if(value != null && value.length > 0){
        value.forEach(a =>{
          if(a.isAdmin==true){
            //管理员角色设置不同颜色来区分
            str = str + "<span class=\"state-info\">"+a.roleName+"</span> ";
          }else{
            str = str + "<span class=\"state-success\">"+a.roleName+"</span> ";
          }
        })
      }
    //表面该HTML是可信赖的
      return this.dom.bypassSecurityTrustHtml(str);
    }

}
